<tsq-generic-modal></tsq-generic-modal>

<div id="global-loading-indicator" *ngIf="routing">
  <tsq-loader />
</div>

<comm-native-app-banner-wrapper></comm-native-app-banner-wrapper>

<router-outlet></router-outlet>
